import React, { useEffect, useState } from "react"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const DashboardDatepicker = ({ onDateChange, setError, initialFromDate, initialToDate }) => {
    const today = new Date();
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(today.getDate() - 29);

    const [fromDate, setFromDate] = useState(initialFromDate || fiveDaysAgo);
    const [toDate, setToDate] = useState(initialToDate || today);
    // const [error, setError] = useState('');
    // Effect to call the onDateChange callback whenever the dates change
    useEffect(() => {
        // Call onDateChange on mount to pass initial dates
        onDateChange(fromDate, toDate);
    }, []); // Empty dependency array to run only on mount

    useEffect(() => {
        // Call onDateChange whenever fromDate or toDate changes
        onDateChange(fromDate, toDate);
    }, [fromDate, toDate]);
    // Calculate the date 5 months ago
    const fiveMonthsAgo = new Date();
    fiveMonthsAgo.setMonth(today.getMonth() - 5);
    const handleFromDateChange = (date) => {
        setFromDate(date);
        setToDate(null); // Clear toDate when fromDate changes
    };
    const handleToDateChange = (date) => {
        if (date && fromDate) {
            // Create new Date objects for comparison, setting time to midnight
            const fromDateOnly = new Date(fromDate);
            fromDateOnly.setHours(0, 0, 0, 0); // Set time to midnight

            const toDateOnly = new Date(date);
            toDateOnly.setHours(0, 0, 0, 0); // Set time to midnight

            const maxToDate = new Date(fromDateOnly);
            maxToDate.setDate(maxToDate.getDate() + 29); // Allow toDate up to 5 days after fromDate

            if (toDateOnly < fromDateOnly) {
                setError(`To Date cannot be less than From Date.`);
                setToDate(null); // Clear toDate if validation fails
            } else if (toDateOnly > maxToDate) {
                setError(`To Date cannot be more than 30 days after From Date.`);
                setToDate(null); // Clear toDate if validation fails
            } else {
                setError(''); // Clear error message if valid
                setToDate(date);
            }
        } else {
            setToDate(date);
        }
    };
    return (
        <>
            <div class="ms-2">
                {/* <DatePicker className='form-control form-control-sm' placeholderText="Form Date" dateFormat="MM/dd/yyyy" /> */}
                <DatePicker
                    showIcon
                    className='form-control form-control-sm' placeholderText="YYYY/MM/DD"
                    selected={fromDate}
                    // onChange={(date) => { setFromDate(date); fromDateChange(date); }}
                    onChange={handleFromDateChange}
                    dateFormat="yyyy/MM/dd"
                    minDate={fiveMonthsAgo}
                    maxDate={new Date()}
                    isClearable
                />
            </div>
            <div class="ms-2">
                {/* <DatePicker className='form-control form-control-sm' placeholderText="To Date" dateFormat="MM/dd/yyyy" /> */}
                <DatePicker
                    showIcon
                    className='form-control form-control-sm' placeholderText="YYYY/MM/DD"
                    selected={toDate}
                    // onChange={(date) => { setToDate(date);}}
                    onChange={handleToDateChange}
                    dateFormat="yyyy/MM/dd"
                    minDate={fiveMonthsAgo}
                    maxDate={new Date()}
                    isClearable
                />
            </div>

        </>
    )
}
export default DashboardDatepicker